export default "__VITE_ASSET__UgqqxJAa__"